import * as Yup from 'yup';
export const AddTeamValidationSchema = Yup.object({
  firstName: Yup.string()
    .matches(/^[A-Z a-z]{3,}$/, 'Enter only character')
    .required('First name field is required'),
  //   lastName: Yup.string()
  //     .matches(/^[A-Z a-z]{3,}$/, 'Enter only character')
  //     .required('Last name field is required'),
  email: Yup.string()
    .matches(
      /^[A-Za-z0-9.]{2,}@[A-Za-z0-9]{3,}[.]{1}[A-Za-z]{2,6}$/,
      'Email not valid'
    )
    .required('Email Field is required'),
  steamTradeUrl: Yup.string()
    .url('Enter a valid Steam trade URL')
    .required('Steam Trade URL is required'),
  steamId: Yup.string()
    .matches(/^[0-9]{6,}$/, 'Enter a valid Steam ID')
    .required('Steam ID is required'),
  password: Yup.string().required('Password field required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Password must be match')
    .required('Confirm field required'),
});

export const updateTeamValidationSchema = Yup.object({
  firstName: Yup.string()
    .matches(/^[A-Z a-z]{3,}$/, 'Enter only character')
    .required('First name field is required'),
  lastName: Yup.string()
    .matches(/^[A-Z a-z]{3,}$/, 'Enter only character')
    .required('Last name field is required'),
  email: Yup.string()
    .matches(
      /^[A-Za-z0-9.]{2,}@[A-Za-z0-9]{3,}[.]{1}[A-Za-z]{2,6}$/,
      'Email not valid'
    )
    .required('Email Field is required'),
});

export const AddAffiliateLevelValidationSchema = Yup.object({
  referrerCommission: Yup.string().required('Commission field is required'),
  refereeBonus: Yup.string().required('Bonus field is required'),
});
